"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffsetBoxDropCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Card = require("../../Card");
var _hooks = require("../../../hooks");
var _Button = require("../../Button");
var _Icon = require("../../Icon");
var _css = require("@emotion/css");
var _OffsetBoxDropCard = _interopRequireDefault(require("./OffsetBoxDropCard.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const OffsetBoxDropCard = exports.OffsetBoxDropCard = /*#__PURE__*/_react.default.forwardRef((props, outerRef) => {
  const {
    id,
    children,
    isAttachedToWindow,
    isWithFilter,
    isFullScreen,
    width,
    position = 'bottom',
    onClose,
    onAnimationComplete
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const [containerStyle, setContainerStyle] = (0, _react.useState)({});
  const styles = (0, _OffsetBoxDropCard.default)();
  const handleClose = event => {
    event?.stopPropagation();
    if (onClose) {
      onClose();
    }
  };
  (0, _react.useEffect)(() => {
    setTimeout(() => {
      setContainerStyle((0, _css.css)({
        opacity: 1,
        transform: 'scaleY(1)',
        transition: 'transform .35s ease-in-out'
      }));
    }, 50);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": id ? `dropdown-${id}` : null,
    ref: outerRef,
    className: `${styles['cc-OffsetBoxDropCard']} ${containerStyle}`,
    style: {
      transformOrigin: isAttachedToWindow || position === 'top' ? 'bottom' : 'top'
    },
    onTransitionEnd: onAnimationComplete,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, {
      width: isAttachedToWindow ? '100vw' : width ? width : 'auto',
      height: isAttachedToWindow && isFullScreen ? '100vh' : 'auto',
      borderRadius: isAttachedToWindow && isFullScreen ? {
        borderStartEndRadius: 0,
        borderStartStartRadius: 0,
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      } : isAttachedToWindow ? {
        borderStartEndRadius: 19,
        borderStartStartRadius: 19,
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      } : isWithFilter ? {
        borderStartEndRadius: 19,
        borderStartStartRadius: 19
      } : {},
      isWithShadow: !isMobileView,
      children: [isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.Card.Section, {
        size: "small",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-OffsetBoxDropCard__close'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            id: "ccOffsetBoxDropCardClose",
            view: "link",
            color: "basic",
            onClick: handleClose,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              name: "Close",
              width: 16,
              height: 16
            })
          })
        })
      }), children]
    })
  });
});